import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { SessionService, SigninService, TermsStatusService } from '@app/core';


@Injectable({
  providedIn: 'root',
})
export class TermsGuard  {
  private _router = inject(Router);
  private _sessionService = inject(SessionService);
  private _signinService = inject(SigninService);
  private _termsStatusService = inject(TermsStatusService);


  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    if (!this._signinService.signedIn()) {
      return of(true);
    }

    const accountId = this._sessionService.account()?.id;
    if (!accountId) {
      return of(true);
    }

    return this._termsStatusService.ensureLoaded(accountId)
      .pipe(
        map((termsStatus) => {
          const skipped = this._sessionService.skippedTermTypesSet();
          if (this._termsStatusService.anyBlocked(termsStatus, skipped)) {
            return this._router.createUrlTree(['/terms'], { queryParams: { redirect: state.url } });
          }

          return true;
        }),
      );
  }

}
